module.exports = __webpack_public_path__ + "static/image-carrusel-hunting-1-a1acb194d0e800031d0f8470dd53aeb0.png";